import {parse, stringify} from 'qs';

class UrlService {

    /**
     * Serializes the given object.
     * @param input: the object to serialize.
     */
    serialize(input: any) {
        return stringify(input, {arrayFormat: 'indices', allowDots: true});
    }

    /**
     * Serializes the given object.
     * @param input: the object to serialize.
     */
    deserialize(input: string) {
        let convertedInput = input;
        if (input.indexOf('?') === 0) {
            convertedInput = input.substr(1, input.length);
        }
        return parse(convertedInput, {allowDots: true});
    }

}

const URL_SERVICE_INSTANCE = new UrlService();

export {URL_SERVICE_INSTANCE};
